import { bool } from 'prop-types';
import React from 'react';

import { campaignLineShape } from '../../prop-types';

function LanguageHeaderLine({ line, showActions }) {
  const { hasTitle, hasSubTitle, hasCta, hasText, hasLp } = line.product;

  return (
    <tr className="small text-muted">
      {/* eslint-disable jsx-a11y/control-has-associated-label */}
      {showActions && <th className="py-0" />}
      <th className="py-0" />
      {/* eslint-enable jsx-a11y/control-has-associated-label */}

      {hasSubTitle && <th className="py-0 font-weight-semi-bold">Headline</th>}

      {hasTitle && <th className="py-0 font-weight-semi-bold">Subline</th>}

      {hasText && <th className="py-0 font-weight-semi-bold">Description</th>}

      {hasCta && <th className="py-0 font-weight-semi-bold">CTA</th>}

      {hasLp && <th className="py-0 font-weight-semi-bold">LP</th>}
    </tr>
  );
}

LanguageHeaderLine.propTypes = {
  line: campaignLineShape.isRequired,
  showActions: bool,
};

LanguageHeaderLine.defaultProps = {
  showActions: true,
};

export default LanguageHeaderLine;
